import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function AuthPage() {
  const { authenticate } = useAuth();
  const notice = useLocation().state?.notice;
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try { await authenticate(mode, { email, password }); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="auth" data-testid="auth-page">
      <div className="auth-hero">
        <div className="brand big"><img className="brand-logo" src="/logo-mark.png" alt="POWER PROFIT logo" data-testid="auth-logo" /><span className="brand-name">POWER PROFIT</span></div>
        <h1 className="auth-title">Know if a boat or RV load pays <em>before</em> you say yes.</h1>
        <p className="auth-copy"><ShieldCheck size={16} /> Your costs are calculated on your phone and never sent to our servers.</p>
      </div>
      <form className="auth-card" onSubmit={submit} data-testid="auth-form">
        <h2>{mode === "login" ? "Sign in" : "Create account"}</h2>
        {notice && <p className="notice" data-testid="auth-notice">{notice}</p>}
        <label className="field"><span className="field-label">Email</span>
          <span className="field-box"><input data-testid="input-auth-email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></span>
        </label>
        <label className="field"><span className="field-label">Password</span>
          <span className="field-box"><input data-testid="input-auth-password" type="password" autoComplete={mode === "login" ? "current-password" : "new-password"} required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} /></span>
        </label>
        {error && <p className="err" data-testid="auth-error">{error}</p>}
        <button className="btn primary" type="submit" disabled={busy} data-testid="btn-auth-submit">{busy ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"}</button>
        <button type="button" className="link-btn" data-testid="btn-auth-toggle-mode" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}>
          {mode === "login" ? "New here? Create an account" : "Have an account? Sign in"}
        </button>
      </form>
    </div>
  );
}
